module.exports = __webpack_public_path__ + "static/media/8_libro-min.cfa22ffd.jpg";